import * as Types from '../constants/Types';
export const syncAllGolf = (filters) =>  ({ type: Types.RATE_SYNC_ALL_GOLF_ACTION, filters });

export const getListGolf = (filters) => ({ type: Types.GOLF_LIST_ACTION, filters });
export const setListGolf = (data) => ({ type: Types.GOLF_LIST_SUCCESS,  golfs: data , pageNumber: data.pageNumber, pageSize: data.pageSize, totalCount: data.totalCount });

export const getGolfDetail = (id) => ({ type: Types.GOLF_DETAIL_ACTION, id });
export const setGolfDetail = (golf) => ({ type: Types.GOLF_DETAIL_SUCCESS, golf });
export const updateGolfDetail = (golf) => ({ type: Types.GOLF_DETAIL_UPDATE_ACTION, golf });
export const updateGolfOrder = (data) => ({ type: Types.GOLF_UPDATE_ORDER_ACTION, data });

export const createGolfTranslate = (golf, language) => ({type: Types.GOLF_CREATE_TRANSLATE_ACTION, golf, language});
export const updateGolfTranslate = (golf, language) => ({type: Types.GOLF_UPDATE_TRANSLATE_ACTION, golf, language});
export const deleteGolfTranslate = (golf, refreshParams) => ({type: Types.GOLF_DELETE_TRANSLATE_ACTION, golf, refreshParams});